import { render, staticRenderFns } from "./Toporgbubble.vue?vue&type=template&id=0d8e77fc"
import script from "./Toporgbubble.vue?vue&type=script&lang=js"
export * from "./Toporgbubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports